import { useEffect } from 'react'

import { showToastMessage } from './Toast'

type NetworkErrorToastProps = {
  className?: string
}

export function useNetworkErrorToast() {
  useEffect(() => {
    const openToast = () => {
      showToastMessage('Network Error! Please check your internet connection.', 'warning')
    }

    if (!window.navigator.onLine) {
      openToast()
    }

    window.addEventListener('offline', openToast)

    return () => window.removeEventListener('offline', openToast)
  }, [])

  return { visible: false, closing: false, dismiss: () => undefined }
}

export function NetworkErrorToast({ className = '' }: NetworkErrorToastProps) {
  useNetworkErrorToast()
  void className

  return null
}
